import { getMeta } from './helpers';

// Set webpack public asset url
window.__webpack_public_path__ = getMeta('theme-url');

import { Application } from '@hotwired/stimulus';
import AxiosFormController from './controllers/axios-form-controller';
import ExpandableController from './controllers/expandable-controller';
import ModalController from './controllers/modal-controller';
import SliderController from './controllers/slider-controller';
import SelectController from './controllers/select-controller';
import TabsController from './controllers/tabs-controller';
import PostsController from './controllers/posts-controller';
import FileUploadController from './controllers/file-upload-controller';
import ProductFilterController from './controllers/product-filter-controller';
import ToggleController from './controllers/toggle-controller';
import WishlistController from './controllers/wishlist-controller';
import SearchController from './controllers/search-controller';
import QuantityController from './controllers/quantity-controller';
import HistoryController from './controllers/history-controller';

require('./floating-image');
require('./navigation');

const application = Application.start();

application.register('axios-form', AxiosFormController);
application.register('modal', ModalController);
application.register('slider', SliderController);
application.register('expandable', ExpandableController);
application.register('select', SelectController);
application.register('tabs', TabsController);
application.register('posts', PostsController);
application.register('file-upload', FileUploadController);
application.register('product-filter', ProductFilterController);
application.register('toggle', ToggleController);
application.register('wishlist', WishlistController);
application.register('search', SearchController);
application.register('quantity', QuantityController);
application.register('history', HistoryController);

(async () => {
    document.body.querySelector('.wp-block-gallery img, .woocommerce-product-gallery__wrapper img, .product-gallery-slider img') && await import('./lightbox')
    document.body.querySelector('.woocommerce-product-visualizer') && await import('./configurator')
})();